import loadable from '@loadable/component';

import { CmsApiStickyHeaderLinksBlockData } from 'modules/cms/api/types/blocks/CmsApiStickyHeaderLinksBlock';
import { CmsAmpLinksBlockLoadable } from 'modules/cms/blocks/Amp/CmsAmpLinksBlockLoadable';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';
import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

export const CmsStickyHeaderLinksBlockMapping: CmsBlockMapping<CmsApiStickyHeaderLinksBlockData> =
  {
    invariant: [
      {
        prop: 'links',
        msg: 'Links required for sticky header links',
      },
    ],
    width: CmsMappedBlockWidth.FULL,
    Component: hydrateOnDemand(
      loadable(() => import('./CmsStickyHeaderLinksBlock'), {
        resolveComponent: (module) => module.CmsStickyHeaderLinksBlock,
      }),
    ),
    AmpComponent: CmsAmpLinksBlockLoadable,
  };
